import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel2';

import repairImg from '../../../assets/img/slider/style2/house-repair.png'

const SliderStyleThree = () => {
    const navPrevIcon = () => ("<i class='fa fa-angle-left'></i>");
    const navNextIcon = () => ("<i class='fa fa-angle-right'></i>");

    const options = {
        items: 1,
        nav: true,
        dots: false,
        margin: 0,
        rewind: false,
        autoplay: false,
        stagePadding: 0,
        loop: true,
        center: false,
        navText: [navPrevIcon, navNextIcon],
        responsive: {
            0: {
                nav: false,
            },
            768: {
                nav: true,
            },
        }
    };

    return (
        <React.Fragment>
            <div className="rs-slider style2">
                <OwlCarousel options={options} >
                    <div className="slider-content slide1">
                        <div className="container">
                            <div className="content-part">
                                <div className="sl-img">
                                    <img src={repairImg} alt="slider" />
                                </div>
                                <h1 className="sl-title">Ceketçiler Tekstil </h1>
                                <h1 className="sl-title2 mb-mb-10">Modanın Kimyası</h1>
                                <div className="sl-desc">
                                    1955'den beri Giyim Sektöründe Tecrübesi ve Çalışma Prensipleriyle Siz Değerli Müşterilerimize İlk Günkü Heyecanımızla Hizmet Vermekteyiz.
                                </div>
                                <div className="sl-btn">
                                    <Link className="readon buy-now sl-btn" to="/hakkimizda">Daha Fazlası</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="slider-content slide2">
                        <div className="container">
                            <div className="content-part">
                                <div className="sl-img">
                                    <img src={repairImg} alt="slider" />
                                </div>
                                <h1 className="sl-title">Ceketçiler Tekstil </h1>
                                <h1 className="sl-title2 mb-mb-10">Modanın Kimyası</h1>
                                <div className="sl-desc">
                                    1955'den beri Giyim Sektöründe Tecrübesi ve Çalışma Prensipleriyle Siz Değerli Müşterilerimize İlk Günkü Heyecanımızla Hizmet Vermekteyiz.
                                </div>
                                <div className="sl-btn">
                                    <Link className="readon buy-now sl-btn" to="/hakkimizda">Daha Fazlası</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </OwlCarousel>
            </div>
        </React.Fragment>
    );
}

export default SliderStyleThree;